<script>
import Swal from "sweetalert2";
import { cloneDeep } from "lodash";
import { required } from "vuelidate/lib/validators";
import { Carousel, Slide } from "vue-carousel";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import MaskedInput from "vue-text-mask";
import Campus from "@/components/modals/campus.vue";
import Building from "@/components/modals/property-locationBuildings.vue";
import PrintOptions from "@/components/modals/print-options.vue";
import MoveCampusModal from "@/components/modals/move-campus-modal.vue";

export default {
  components: {
    Carousel,
    Slide,
    MaskedInput,
    Campus,
    Building,
    PrintOptions,
    MoveCampusModal
  },
  props: {
    selectedCampus: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      quantityMask: createNumberMask({
        prefix: "",
        includeThousandsSeparator: false
      }),
      submitted: false,
      // campusSelect: "",
      // campusList: ["Show All"],
      tableData: [],
      modalTitle: "",
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: "",
      filterLocation: "",
      sortDesc: false,
      fields: [
        {
          key: "colCheck",
          sortable: false,
          thStyle: { width: "60px" },
        },
        {
          key: "buildingName",
          sortable: true,
        },
        // {
        //   key: "buildingLocation",
        //   thStyle: { width: "200px" },
        //   label: "Campus",
        //   sortable: true,
        //   tdClass: "align-middle"
        // },
        {
          key: "buildingDescription",
          thStyle: { width: "250px" },
          sortable: true,
          tdClass: "align-middle"
        },
        {
          key: "actions",
          thStyle: { width: "90px" },
          tdClass: "align-middle"
        }
      ],
      fieldsLocation: [
        {
          key: "id",
          sortable: true,
          tdClass: "align-middle",
          thStyle: { width: "100px" }
        },
        {
          key: "location",
          sortable: true,
          tdClass: "align-middle"
        },
        {
          key: "locationCode",
          thStyle: { width: "200px" },
          sortable: true,
          tdClass: "align-middle"
        },
        {
          key: "floorNumber",
          thStyle: { width: "130px" },
          tdClass: "align-middle"
        },
        {
          key: "roomNumber",
          thStyle: { width: "130px" },
          tdClass: "align-middle"
        },
        {
          key: "actions",
          thStyle: { width: "90px" },
          tdClass: "align-middle"
        }
      ],
      fieldsArea: [
        {
          key: "area",
          sortable: true,
          tdClass: "align-middle"
        }
      ],
      locations: null,
      area: null,
      form: {
        id: 0,
        buildingName: "",
        buildingLocation: "",
        buildingDescription: "",
        campusId: null
      },
      formLocation: {
        id: 0,
        location: "",
        locationCode: "",
        floorNumber: null,
        roomNumber: null,
        buildingId: null,
        isWarehouse: false
      },
      building: "",
      campus: "",
      buildingIndex: -1,
      locationIndex: -1,
      areaIndex: -1,
      tableBusy: false,
      filterLocationSelect: "1",
      carouselPage: 0
    };
  },
  computed: {
    filtered() {
      let data = this.tableData;
      // if (this.campusSelect && this.campusSelect != "Show All") {
      //   data = data.filter((item) => {
      //     if (
      //       item.buildingLocation
      //         .toUpperCase()
      //         .includes(this.campusSelect.toUpperCase())
      //     ) {
      //       return item.buildingLocation
      //         .toUpperCase()
      //         .includes(this.campusSelect.toUpperCase());
      //     }
      //   });
      // }

      if (this.filter.trim() != "" && this.filter) {
        data = data.filter((item) => {
          if (
            item.buildingName.toUpperCase().includes(this.filter.toUpperCase())
          ) {
            return item.buildingName
              .toUpperCase()
              .includes(this.filter.toUpperCase());
          } else if (
            item.buildingDescription
              .toUpperCase()
              .includes(this.filter.toUpperCase())
          ) {
            return item.buildingDescription
              .toUpperCase()
              .includes(this.filter.toUpperCase());
          } else if (
            item.id == this.filter
          ) {
            return item.id == this.filter;
          }
        });
      }
      return data;
    },
    checkAllBldg: {
      get() {
        return this.filtered.length > 0 && this.filtered.every((item) => item.checked);
      },
      set(value) {
        this.filtered.forEach((item) => {
          item.checked = value;
        });
      }
    },
    selectedBldg() {
      return this.tableData.filter((item) => item.checked);
    },
    rows() {
      if (this.filter.trim() != "" && this.filter) {
        return this.filtered.length;
      } else {
        return this.tableData.length;
      }
    },
    filteredLocation() {
      let array = this.locations.locations;
      if (this.filterLocationSelect != "1") {
        array = array.filter((item) => {
          if (this.filterLocationSelect == "2") {
            return !item.isWarehouse;
          } else if (this.filterLocationSelect == "3") {
            return item.isWarehouse;
          }
        });
      }

      let keyword = this.filterLocation;
      const regExp = new RegExp(keyword, "gi");
      const check = (obj) => {
        if (obj !== null && typeof obj === "object") {
          return Object.values(obj).some(check);
        }
        if (Array.isArray(obj)) {
          return obj.some(check);
        }
        return (
          (typeof obj === "string" || typeof obj === "number") &&
          regExp.test(obj)
        );
      };
      return array.filter(check);
    },
    rowsLocation() {
      if (this.filterLocation.trim() != "" && this.filterLocation) {
        return this.filteredLocation.length;
      } else {
        return this.locations.locations.length;
      }
    }
  },
  validations: {
    form: {
      buildingName: { required },
      campusId: { required }
    }
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      if (this.selectedCampus) {
        this.getPreviousPage();
        this.tableBusy = true;
        this.$store
          .dispatch("propertylocation/GetBuilding", this.selectedCampus)
          .then((res) => {
            this.tableBusy = false;
            if (res.data.error) {
              return this.showToast(res.data.errorMessage, "error");
            }
            res.data.forEach((item) => {
              // if (
              //   item.buildingLocation != "" &&
              //   !this.campusList.includes(item.buildingLocation)
              // )
              //   this.campusList.push(item.buildingLocation);
              item.currentPage = 1;
              item.perPage = 10;
              item.tableBusy = false;
              item.locations = [];
              item.checked = false;
            });
            // this.campusSelect = this.campusList[0];
            this.tableData = res.data;
          })
          .catch(() => {
            this.tableBusy = false;
            return this.showToast(
              "Something went wrong - getting location list!",
              "error"
            );
          });
      }
    },
    getLocation() {
      this.locations.tableBusy = true;
      this.locations.currentPage = 1;
      this.locations.perPage = 10;
      this.filterLocation = "";
      this.locations.locations = [];
      this.$store
        .dispatch("propertylocation/GetPropertyLocation", this.locations.id)
        .then((res) => {
          if (res.data.error) {
            return this.showToast(res.data.errorMessage, "error");
          }
          this.locations.locations = res.data;
          this.locations.tableBusy = false;
        })
        .catch(() => {
          this.locations.tableBusy = false;
          return this.showToast(
            "Something went wrong - getting location list!",
            "error"
          );
        });
    },
    getNextPage(row) {
      if (this.$refs.carouselLocation) {
        this.carouselPage = 1;
        this.locations = cloneDeep(row);
        this.getLocation();
        this.$refs.carouselLocation.goToPage(
          this.$refs.carouselLocation.getNextPage()
        );
      }
    },
    getPreviousPage() {
      if (this.$refs.carouselLocation) {
        this.carouselPage = 0;
        this.locations = null;
        this.$refs.carouselLocation.goToPage(
          this.$refs.carouselLocation.getPreviousPage()
        );
      }
    },
    onCreateBuilding() {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        if (this.form.id > 0) {
          this.$store
            .dispatch("propertylocation/UpdateBuilding", this.form)
            .then((res) => {
              // if (
              //   res.data.buildingLocation != "" &&
              //   !this.campusList.includes(res.data.buildingLocation)
              // )
              //   this.campusList.push(res.data.buildingLocation);
              res.data.currentPage = 1;
              res.data.perPage = 10;
              res.data.tableBusy = false;
              res.data.locations = [];
              this.tableData.splice(this.buildingIndex, 1, res.data);
              this.$bvModal.hide("build-modal");
              return this.showToast("Successfully updated!", "success");
            })
            .catch((err) => {
              return this.showToast(
                "Something went wrong - updating building!",
                "error"
              );
            });
        } else {
          this.$store
            .dispatch("propertylocation/CreateBuilding", this.form)
            .then((res) => {
              // if (
              //   res.data.buildingLocation != "" &&
              //   !this.campusList.includes(res.data.buildingLocation)
              // )
              //   this.campusList.push(res.data.buildingLocation);
              res.data.currentPage = 1;
              res.data.perPage = 10;
              res.data.tableBusy = false;
              res.data.locations = [];
              this.tableData.push(res.data);
              this.$bvModal.hide("build-modal");
              return this.showToast("Successfully created!", "success");
            })
            .catch((err) => {
              return this.showToast(
                "Something went wrong - creating building!",
                "error"
              );
            });
        }
        this.submitted = false;
      }
    },
    addBuilding() {
      this.onReset();
      this.form.campusId = this.selectedCampus;
      this.modalTitle = "Create New Building";
      this.$bvModal.show("build-modal");
    },
    updateBuilding(props) {
      this.form = cloneDeep(props.item);
      this.buildingIndex = this.tableData.findIndex(
        (item) => item.id == props.item.id
      );
      this.modalTitle = "Update Building";
      this.$bvModal.show("build-modal");
    },
    deleteBuilding(props) {
      var index = this.tableData.findIndex((item) => item.id == props.item.id);
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, delete it!"
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("propertylocation/DeleteBuilding", props.item.id)
            .then((res) => {
              this.tableData.splice(index, 1);
              return this.showToast("Successfully deleted", "success");
            })
            .catch((err) => {
              return this.showToast("Cannot be deleted!", "error");
            });
        }
      });
    },
    onCreateLocation() {
      this.submitted = true;
      if (
        this.formLocation.location == "" ||
        this.formLocation.location == null ||
        this.formLocation.locationCode == "" ||
        this.formLocation.locationCode == null
      ) {
        return;
      } else {
        if (this.formLocation.floorNumber)
          this.formLocation.floorNumber = this.getExactAmt(
            this.formLocation.floorNumber
          );
        else this.formLocation.floorNumber = 0;
        if (this.formLocation.roomNumber)
          this.formLocation.roomNumber = this.getExactAmt(
            this.formLocation.roomNumber
          );
        else this.formLocation.roomNumber = 0;
        if (this.formLocation.id > 0) {
          this.$store
            .dispatch(
              "propertylocation/UpdatePropertyLocation",
              this.formLocation
            )
            .then((res) => {
              this.locations.locations.splice(
                this.locationIndex,
                1,
                this.formLocation
              );
              this.$bvModal.hide("loc-modal");
              return this.showToast("Successfully updated!", "success");
            })
            .catch((err) => {
              return this.showToast(
                "Something went wrong - updating location!",
                "error"
              );
            });
        } else {
          this.$store
            .dispatch(
              "propertylocation/CreatePropertyLocation",
              this.formLocation
            )
            .then((res) => {
              this.locations.locations.push(res.data);
              this.$bvModal.hide("loc-modal");
              return this.showToast("Successfully created!", "success");
            })
            .catch((err) => {
              return this.showToast(
                "Something went wrong - creating location!",
                "error"
              );
            });
        }
        this.submitted = false;
      }
    },
    addLocation() {
      this.onReset();
      this.formLocation.buildingId = this.locations.id;
      this.modalTitle = "Create New Location";
      this.$bvModal.show("loc-modal");
    },
    updateLocation(props) {
      this.formLocation = cloneDeep(props.item);
      this.formLocation.buildingId = this.locations.id;
      this.building = this.locations.buildingName;
      this.formLocation.floorNumber = props.item.floorNumber.toString();
      this.formLocation.roomNumber = props.item.roomNumber.toString();
      this.locationIndex = this.locations.locations.findIndex(
        (item) => item.id == props.item.id
      );
      this.modalTitle = "Update Location";
      this.$bvModal.show("loc-modal");
    },
    deleteLocation(props) {
      var index = this.locations.locations.findIndex(
        (item) => item.id == props.item.id
      );
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, delete it!"
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("propertylocation/DeletePropertyLocation", props.item.id)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              this.locations.locations.splice(index, 1);
              return this.showToast("Successfully deleted", "success");
            })
            .catch((err) => {
              return this.showToast("Cannot be deleted!", "error");
            });
        }
      });
    },
    onReset() {
      this.submitted = false;
      this.form = {
        id: 0,
        buildingName: "",
        buildingLocation: "",
        buildingDescription: "",
        campusId: null
      };
      this.formLocation = {
        id: 0,
        location: "",
        locationCode: "",
        floorNumber: null,
        roomNumber: null,
        buildingId: null,
        isWarehouse: false
      };
      this.building = "";
      this.campus = "";
    },
    getCampus() {
      this.$refs.campus.getData();
      this.$bvModal.show("campus-modal");
    },
    dropCampus(data) {
      this.form.campusId = data.id;
      this.campus = data.campusName;
    },
    getBuilding() {
      this.$refs.building.getData();
      this.$bvModal.show("building-modal");
    },
    dropBuilding(data) {
      this.formLocation.buildingId = data.id;
      this.building = data.buildingName;
    },
    moveCampusSubmit(campusId) {
      this.$store
        .dispatch("propertylocation/TransferBuilding", { id: campusId, arr: this.selectedBldg.map(x => {
          return { id: x.id }
        }) })
        .then(async (res) => {
            if(res.data.error){
                return this.showToast(res.data.errorMessage, "error");
            }
            this.selectedBldg.forEach(item => {
              const index = this.tableData.findIndex(x => x.id == item.id);
              if(index !== -1) {
                this.tableData.splice(index, 1);
              }
            });
            this.$bvModal.hide('move-campus-modal');
            this.showToast("Buildings moved to campus successfully!", "success");
        })
        .catch((err) => {
            this.showToast(
                "Something went wrong! - moving buildings to campus",
                "error"
            );
        });
    },
    transferToOtherCampus() {
      this.$refs.moveCampusModal.getData();
      this.$bvModal.show("move-campus-modal");
    }
  }
};
</script>

<template>
  <div class="card border">
    <div class="card-body">
      <!-- Create / Update Building -->
      <b-modal
        id="build-modal"
        :title="modalTitle"
        size="md"
        title-class="font-18"
        hide-footer
        no-close-on-backdrop
      >
        <form
          @submit.prevent="onCreateBuilding"
          class="needs-validation"
          ref="accForm"
        >
          <div class="mb-3">
            <label for="buildingName">Name</label>
            <input
              autocomplete="off"
              id="buildingName"
              type="text"
              v-model="form.buildingName"
              placeholder="Enter Name..."
              class="form-control"
              :class="{
                'is-invalid': submitted && $v.form.buildingName.$error
              }"
            />
            <div
              v-if="submitted && $v.form.buildingName.$error"
              class="invalid-feedback"
            >
              <span v-if="!$v.form.buildingName.required"
                >This value is required.</span
              >
            </div>
          </div>
          <div class="mb-3">
            <label for="buildingDescription">Description</label>
            <textarea
              id="buildingDescription"
              rows="2"
              v-model="form.buildingDescription"
              placeholder="Enter Description..."
              class="form-control"
              autocomplete="off"
            ></textarea>
          </div>
          <div class="d-flex justify-content-end">
            <button type="submit" class="btn btn-primary">
              {{ form.id > 0 ? "Update" : "Create" }}
            </button>
          </div>
        </form>
      </b-modal>
      <!-- Create / Update Location -->
      <b-modal
        id="loc-modal"
        :title="modalTitle"
        size="md"
        title-class="font-18"
        hide-footer
        no-close-on-backdrop
      >
        <form
          @submit.prevent="onCreateLocation"
          class="needs-validation"
          ref="accForm"
        >
          <div class="mb-3">
            <div class="form-check form-checkbox-outline form-check-success">
              <input
                type="checkbox"
                id="autoGenerate"
                checked="checked"
                class="form-check-input"
                v-model="formLocation.isWarehouse"
              /><label for="autoGenerate" class="form-check-label">
                Set as Warehouse
              </label>
            </div>
          </div>
          <div class="mb-3">
            <label for="location">Location </label>
            <input
              autocomplete="off"
              id="location"
              type="text"
              v-model="formLocation.location"
              placeholder="Enter Location..."
              class="form-control"
              :class="{
                'is-invalid':
                  submitted &&
                  (formLocation.location == '' || formLocation.location == null)
              }"
            />
            <div
              v-if="
                submitted &&
                  (formLocation.location == '' || formLocation.location == null)
              "
              class="invalid-feedback"
            >
              <span>This value is required.</span>
            </div>
          </div>
          <div class="mb-3">
            <label for="locationCode">Location Code</label>
            <input
              autocomplete="off"
              id="locationCode"
              type="text"
              v-model="formLocation.locationCode"
              placeholder="Enter Location Code..."
              class="form-control"
              :class="{
                'is-invalid':
                  submitted &&
                  (formLocation.locationCode == '' ||
                    formLocation.locationCode == null)
              }"
            />
            <div
              v-if="
                submitted &&
                  (formLocation.locationCode == '' ||
                    formLocation.locationCode == null)
              "
              class="invalid-feedback"
            >
              <span>This value is required.</span>
            </div>
          </div>
          <div v-if="formLocation.id > 0" class="mb-3">
            <label for="buildingId">Building</label>
            <b-input-group>
              <template #append>
                <b-button
                  @click="getBuilding"
                  variant="outline-info"
                  title="Select Building"
                  ><i class="mdi mdi-clipboard-text-search-outline"></i
                ></b-button>
              </template>
              <input
                autocomplete="off"
                type="text"
                placeholder="Select Building..."
                disabled
                class="form-control"
                :class="{
                  'is-invalid':
                    submitted &&
                    (formLocation.buildingId == '' ||
                      formLocation.buildingId == null)
                }"
                v-model="building"
              />
            </b-input-group>
            <div
              v-if="
                submitted &&
                  (formLocation.buildingId == '' ||
                    formLocation.buildingId == null)
              "
              class="invalid-feedback"
            >
              <span>This value is required.</span>
            </div>
          </div>
          <div class="mb-3">
            <label for="floorNumber">Floor Number </label>
            <masked-input
              id="floorNumber"
              type="text"
              v-model="formLocation.floorNumber"
              placeholder="Enter Floor Number..."
              class="form-control"
              autocomplete="off"
              :mask="quantityMask"
            ></masked-input>
          </div>
          <div class="mb-3">
            <label for="roomNumber">Room Number </label>
            <masked-input
              id="roomNumber"
              type="text"
              v-model="formLocation.roomNumber"
              placeholder="Enter Room Number..."
              class="form-control"
              autocomplete="off"
              :mask="quantityMask"
            ></masked-input>
          </div>
          <div class="d-flex justify-content-end">
            <button type="submit" class="btn btn-primary">
              {{ formLocation.id > 0 ? "Update" : "Create" }}
            </button>
          </div>
        </form>
      </b-modal>
      <!-- Main -->
      <carousel
        ref="carouselLocation"
        class="events navs-carousel"
        id="timeline-carousel"
        :navigation-enabled="false"
        :pagination-enabled="false"
        :perPage="1"
        :autoplay="false"
        :minSwipeDistance="0"
        :mouseDrag="false"
      >
        <slide class="p-0">
          <div v-if="carouselPage == 0">
            <div class="row mt-1 mb-3">
              <div class="col-sm-12 col-md-6">
                <div class="d-flex align-items-center h-100">
                  <h5 class="mb-0">Building List</h5>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div class="d-flex justify-content-end align-items-center">
                  <button 
                    type="button" 
                    v-if="selectedBldg.length" 
                    class="btn btn-sm btn-success"
                    @click="transferToOtherCampus"
                  >
                    Transfer Building to Another Campus ({{ selectedBldg.length }})
                  </button>
                  <button
                    type="button"
                    @click="addBuilding()"
                    class="ms-2 btn btn-sm btn-info d-flex align-items-center"
                  >
                    <i class="bx bx-plus me-2 fs-6"></i>Create New
                  </button>
                </div>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-6">
                <!-- <b-form-select
                  class="form-select w-50"
                  v-model="campusSelect"
                  :options="campusList"
                ></b-form-select> -->
              </div>
              <div class="col-6">
                <label class="d-flex align-items-center">
                  <b-form-input
                    autocomplete="off"
                    v-model="filter"
                    type="search"
                    placeholder="Search building..."
                    class="form-control mx-2 w-75"
                  ></b-form-input>
                  <b-form-select
                    class="form-select w-25"
                    v-model="perPage"
                    :options="pageOptions"
                  ></b-form-select>
                </label>
              </div>
            </div>
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="filtered"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                sort-by="id"
                :sort-desc.sync="sortDesc"
                :busy="tableBusy"
                bordered
                outlined
                striped
                show-empty
              >
                <template #empty>
                  <div class="text-center">
                    <div>
                      <i class="fas fa-exclamation-triangle me-2"></i>No Data
                      Found
                    </div>
                  </div>
                </template>
                <template #table-busy>
                  <div class="d-flex justify-content-center align-items-center">
                    <div class="preloader-component me-2">
                      <div class="status">
                        <div class="spinner-chase w-20px h-20px">
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                        </div>
                      </div>
                    </div>
                    <strong>Loading...</strong>
                  </div>
                </template>
                <template #head(colCheck)>
                  <div class="form-check form-checkbox-outline form-check-success mb-0">
                    <input
                      type="checkbox"
                      id="checkAllBldg"
                      checked="checked"
                      class="form-check-input"
                      v-model="checkAllBldg"
                    />
                  </div>
                </template>
                <template #cell(colCheck)="row">
                  <div class="form-check form-checkbox-outline form-check-success mb-0">
                    <input
                      type="checkbox"
                      :id="`checkBldg-${row.item.id}`"
                      checked="checked"
                      class="form-check-input"
                      v-model="row.item.checked"
                    />
                  </div>
                </template>
                <template #cell(actions)="row">
                  <div
                    class="d-flex justify-content-between align-items-center"
                  >
                    <div class="font-size-12 me-3" style="width: max-content">
                      <a
                        href="javascript: void(0);"
                        class="text-info d-flex align-items-center"
                        @click="getNextPage(row.item)"
                      >
                        View Locations
                        <i class="bx bx-chevron-right rotate font-size-14"></i>
                      </a>
                    </div>

                    <i
                      class="fas fa-ellipsis-v cursor-pointer ps-2 pe-2 ms-2"
                      :id="`building-popover-${row.item.id}`"
                      tabindex="0"
                    ></i>
                    <b-popover
                      :target="`building-popover-${row.item.id}`"
                      triggers="click blur"
                      placement="leftbottom"
                      variant="secondary"
                      custom-class="p-0"
                    >
                      <b-list-group class="w-100 fit">
                        <b-list-group-item
                          button
                          action
                          class="d-flex align-items-center text-info"
                          @click="updateBuilding(row)"
                          ><i class="mdi mdi-update font-size-18 me-1"></i
                          >Update Item</b-list-group-item
                        >
                        <b-list-group-item
                          button
                          action
                          class="d-flex align-items-center text-danger"
                          @click="deleteBuilding(row)"
                          ><i class="mdi mdi-trash-can font-size-18 me-1"></i
                          >Delete</b-list-group-item
                        >
                      </b-list-group>
                    </b-popover>
                  </div>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </slide>
        <slide class="p-0">
          <div v-if="carouselPage == 1">
            <div class="row mt-1 mb-3">
              <div class="col-sm-12 col-md-6">
                <div class="d-flex align-items-center h-100">
                  <a
                    href="javascript:void(0);"
                    class="d-flex align-items-center"
                    @click="getPreviousPage()"
                    ><i class="bx bx-left-arrow-alt fs-2 me-1"></i>
                    <h5 class="m-0">Location List</h5>
                  </a>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div class="d-flex justify-content-end align-items-center">
                  <button
                    type="button"
                    @click="addLocation()"
                    class="ms-2 btn btn-sm btn-info d-flex align-items-center"
                  >
                    <i class="bx bx-plus me-2 fs-6"></i>Create New
                  </button>
                </div>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-6">
                <b-form-select
                  class="form-select w-50"
                  v-model="filterLocationSelect"
                >
                  <option value="1">Show All</option>
                  <option value="2">Location</option>
                  <option value="3">Warehouse</option>
                </b-form-select>
              </div>
              <div class="col-6">
                <label class="d-flex align-items-center">
                  <b-form-input
                    autocomplete="off"
                    v-model="filterLocation"
                    type="search"
                    placeholder="Search location..."
                    class="form-control mx-2 w-75"
                  ></b-form-input>
                  <b-form-select
                    class="form-select w-25"
                    v-model="locations.perPage"
                    :options="pageOptions"
                  ></b-form-select>
                </label>
              </div>
            </div>
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="filteredLocation"
                :fields="fieldsLocation"
                responsive="sm"
                :per-page="locations.perPage"
                :current-page="locations.currentPage"
                sort-by="id"
                :sort-desc.sync="sortDesc"
                :busy="locations.tableBusy"
                bordered
                outlined
                striped
                show-empty
              >
                <template #empty>
                  <div class="text-center">
                    <div>
                      <i class="fas fa-exclamation-triangle me-2"></i>No Data
                      Found
                    </div>
                  </div>
                </template>
                <template #table-busy>
                  <div class="d-flex justify-content-center align-items-center">
                    <div class="preloader-component me-2">
                      <div class="status">
                        <div class="spinner-chase w-20px h-20px">
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                        </div>
                      </div>
                    </div>
                    <strong>Loading...</strong>
                  </div>
                </template>
                <template #cell(location)="row">
                  <span>{{ row.item.location }}</span>
                  <span v-if="row.item.isWarehouse" class="ms-1">
                    (<span class="text-info">Warehouse</span>)
                  </span>
                </template>
                <template #cell(actions)="row">
                  <div class="d-flex float-end">
                    <i
                      class="fas fa-ellipsis-v cursor-pointer ps-2 pe-2 ms-2"
                      :id="`location-popover-${row.item.id}`"
                      tabindex="0"
                    ></i>
                    <b-popover
                      :target="`location-popover-${row.item.id}`"
                      triggers="click blur"
                      placement="leftbottom"
                      variant="secondary"
                      custom-class="p-0"
                    >
                      <b-list-group class="w-100 fit">
                        <b-list-group-item
                          button
                          action
                          class="d-flex align-items-center text-info"
                          @click="updateLocation(row)"
                          ><i class="mdi mdi-update font-size-18 me-1"></i
                          >Update Item</b-list-group-item
                        >
                        <b-list-group-item
                          button
                          action
                          class="d-flex align-items-center text-danger"
                          @click="deleteLocation(row)"
                          ><i class="mdi mdi-trash-can font-size-18 me-1"></i
                          >Delete</b-list-group-item
                        >
                      </b-list-group>
                    </b-popover>
                  </div>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination
                      v-model="locations.currentPage"
                      :total-rows="rowsLocation"
                      :per-page="locations.perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </slide>
      </carousel>
    </div>
    <Campus ref="campus" @dropData="dropCampus($event)"></Campus>
    <Building ref="building" @dropData="dropBuilding($event)"></Building>
    <print-options ref="printOpt"></print-options>
    <MoveCampusModal ref="moveCampusModal" @moveCampus="moveCampusSubmit" />    
  </div>
</template>

<style>
.propertyTable tr td {
  padding: 0 !important;
  margin: 0 !important;
}
</style>
